import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-third-party-api-binding',
  templateUrl: './third-party-api-binding.component.html',
  styleUrls: ['./third-party-api-binding.component.scss']
})
export class ThirdPartyApiBindingComponent implements OnInit {

  payCheck = false;
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  authenticate(){
    this.payCheck = !this.payCheck;
  }

  openDialogWithRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
    });
  }

  close() {
    this.dialog.closeAll();
  }
  
  remove(){

  }

}
